import script from "./Regions.vue?vue&type=script&setup=true&lang=js"
export * from "./Regions.vue?vue&type=script&setup=true&lang=js"

import "./Regions.vue?vue&type=style&index=0&id=2581ede2&lang=stylus"

const __exports__ = script;

export default __exports__